var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFire = function SvgFire(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 16.0002C11.666 16.0002 14.6379 13.2141 14.6379 9.77723C14.6379 5.83261 10.2346 1.64907 8.60066 0.232494C8.25291 -0.0690105 7.74704 -0.0690378 7.39925 0.232432C5.76531 1.64876 1.36212 5.83158 1.36212 9.77723C1.36212 13.2141 4.33399 16.0002 7.99999 16.0002ZM8 14.0002C9.55361 14.0002 10.8131 12.7408 10.8131 11.1872C10.8131 9.90878 9.86071 8.55108 8.73967 7.32653C8.3414 6.89148 7.65861 6.89148 7.26034 7.32653C6.13929 8.55107 5.18695 9.90878 5.18695 11.1872C5.18695 12.7408 6.4464 14.0002 8 14.0002Z",
    fill: "currentcolor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFire);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fire.33f1b4efefb7fdc00f0731d53474f6eb.svg";